module.exports = __webpack_public_path__ + "static/media/Nunito-SemiBold.2ce4576c.woff2";